import React, { useEffect, useState } from 'react';
import { LogOut } from 'lucide-react';
import { authEnabled, currentUserName, signOut } from '../services/auth';

// Signed-in user + sign-out, styled for the dark sidebar footer. Renders
// nothing when sign-in is off (alb mode / local dev), so the footer looks
// exactly as before there.
export default function SignOutButton({ compact = false }) {
  const [name, setName] = useState(null);
  const [signingOut, setSigningOut] = useState(false);

  useEffect(() => {
    let live = true;
    currentUserName().then((n) => { if (live) setName(n); });
    return () => { live = false; };
  }, []);

  if (!authEnabled()) return null;

  const handleClick = () => {
    setSigningOut(true);
    // Also ends the identity-provider session, so the next person on a shared
    // machine has to sign in themselves.
    signOut().catch(() => setSigningOut(false));
  };

  if (compact) {
    // The collapsed sidebar: just the icon, the name in its tooltip.
    return (
      <button onClick={handleClick} disabled={signingOut}
        aria-label="Sign out" title={name ? `Sign out (${name})` : 'Sign out'}
        className="w-full flex justify-center p-3 rounded-xl text-slate-300 hover:bg-white/5 hover:text-white transition-all duration-200 group disabled:opacity-50">
        <LogOut className="w-4 h-4 text-slate-400 group-hover:text-white" />
      </button>
    );
  }

  return (
    <div className="space-y-2">
      {name && (
        <p className="text-[11px] text-slate-400 font-medium truncate" title={name}>
          Signed in as <span className="text-slate-200 font-bold">{name}</span>
        </p>
      )}
      <button
        onClick={handleClick}
        disabled={signingOut}
        className="w-full flex items-center gap-3 px-3 py-2 rounded-xl text-slate-300 hover:bg-white/5 hover:text-white font-medium transition-all duration-200 group disabled:opacity-50"
      >
        <LogOut className="w-4 h-4 text-slate-400 group-hover:text-white" />
        <span className="text-sm">{signingOut ? 'Signing out…' : 'Sign out'}</span>
      </button>
    </div>
  );
}
